/* Confirm for delete */

const formDeleteAudio = document.querySelector('#form-audio-delete');

if (formDeleteAudio) {
  formDeleteAudio.addEventListener('submit', (event) => {
    if (confirm(formDeleteAudio.dataset.confirmMessage)) {
      formDeleteAudio.action = formDeleteAudio.dataset.action;
    } else {
      event.preventDefault();
    }
  });
}
